import { render } from "./privateLetter.vue?vue&type=template&id=626f5c38&scoped=true"
import script from "./privateLetter.vue?vue&type=script&lang=js"
export * from "./privateLetter.vue?vue&type=script&lang=js"

import "./privateLetter.vue?vue&type=style&index=0&id=626f5c38&lang=scss&scoped=true"
import "./privateLetter.vue?vue&type=style&index=1&id=626f5c38&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626f5c38"]])

export default __exports__